import React, { ReactNode, useContext, useEffect } from "react";
import { MediaLib, MediaLibConfig, useMediaLib } from "./useMediaLib";

interface IMediaLibContext extends MediaLib {
  isAvailable?: boolean;
}

const MediaLibContext = React.createContext<IMediaLibContext>({
    data: [],
    isLoading: true,
    isUploading: false,
    protectedFiles: false,
    filter: "",
    setFilter: () => { },
    getFilepath: mf => mf.filename,
    reload: () => { },
    downloadFile: () => { throw new Error("Missing media lib context"); },
    updateFileInfo: () => { throw new Error("Missing media lib context"); },
    exportAll: () => { throw new Error("Missing media lib context"); },
    removeFile: () => { throw new Error("Missing media lib context"); },
    replaceFile: () => { throw new Error("Missing media lib context"); },
    uploadFile: () => { throw new Error("Missing media lib context"); },
});

export interface MediaLibProviderProps extends MediaLibConfig {
    apiPath: string;
    spaceId: string;
    children?: ReactNode;
}

export const MediaLibProvider = (props: MediaLibProviderProps) => {
    const data = useMediaLib(props.apiPath, props.spaceId, props);

    return (
        <MediaLibContext.Provider value={{ isAvailable: true, ...data }}>
            {props.children}
        </MediaLibContext.Provider>
    );
}

export const useMediaLibContext = () => useContext(MediaLibContext);


export const useEnsureMediaLibLoaded = (medialib: MediaLib, shouldLoad: boolean) => {
  useEffect(() => {
    if(shouldLoad && medialib.requestLoad) {
      medialib.requestLoad();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldLoad]);
}

export const useEnsureMediaLibContextLoaded = (shouldLoad: boolean) => {
  const medialib = useMediaLibContext();
  useEnsureMediaLibLoaded(medialib, shouldLoad);
}
